import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../helper/axiosIntance';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  queue_id:null,
};

const slice = createSlice({
  name: 'queue',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET PROFILE
     statusSelectedQueueSuccess(state, action) {
      state.isLoading = false;
      state.queue_id = action.payload;
    },


  }
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow, deleteUser } = slice.actions;

// ----------------------------------------------------------------------

export function selectedQueue(queue_id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
        
      dispatch(slice.actions.statusSelectedQueueSuccess(queue_id));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
